import { noop } from 'lodash'

import {
  ConfirmationForm,
  type IConfirmationFormProps,
} from './components/ConfirmationForm'
import { ConfirmationModalStyled } from './styles/ConfirmationModalStyled'
import { type IModalProps, Modal } from '../Modal'
import { type IconTypes, Icon } from '@ui/elements/Icon'
import { Space } from '@ui/elements/Space'

export interface IConfirmationModalProps
  extends Omit<IConfirmationFormProps, 'handleConfirm'> {
  icon?: IconTypes | null
  open?: boolean
  /** The text of the confirmation modal */
  header?: string
  maxWidth?: IModalProps['maxWidth']
  onConfirm?: IConfirmationFormProps['handleConfirm']
  handleDismiss?: () => void
}

export const ConfirmationModal = ({
  open,
  type,
  icon = 'question',
  header = 'Confirmation',
  maxWidth,
  handleDismiss,
  onConfirm = noop,
  ...otherConfirmationFormProps
}: IConfirmationModalProps) => {
  return (
    <Modal
      aria-labelledby='confirmation-modal-title'
      open={open}
      maxWidth={maxWidth}
      onClose={handleDismiss}
    >
      <Modal.Card>
        <ConfirmationModalStyled>
          <Modal.Header onClose={handleDismiss}>
            {icon ? (
              <Space direction='horizontal' size='small' align='center'>
                <Icon icon={icon} color={type} fontSize={24} />
                <span id='confirmation-modal-title'>{header}</span>
              </Space>
            ) : (
              <span id='confirmation-modal-title'>{header}</span>
            )}
          </Modal.Header>
          <Modal.Content>
            <ConfirmationForm
              type={type}
              handleDismiss={handleDismiss}
              handleConfirm={onConfirm}
              {...otherConfirmationFormProps}
            />
          </Modal.Content>
        </ConfirmationModalStyled>
      </Modal.Card>
    </Modal>
  )
}

ConfirmationModal.displayName = 'ConfirmationModal'
